import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <Link to="/" className="footer-logo">
            <img src="/images/logo.jpg" alt="F&F AI Automation" className="footer-logo-img" />
          </Link>

          <div className="footer-links">
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} F&F AI Automation Services & Products UG (haftungsbeschränkt) 
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
